import { Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay } from "@chakra-ui/core";
import React, { useState, ChangeEvent, useEffect } from "react";
import { useCallback } from "react";
import Button from "src/components/Button";
import Toast from "src/components/Toast";
import useUserPreferences from "src/hooks/useUserPreferences";
import userPreferencesService from "src/service/userPreferences";
import { Checkbox, modalStyle } from "./styles";
interface IProps {
  opened: boolean;
  onClose: () => void;
  colsPref: string[];
  prefKey: string;
}

const UserPreferences = ({ opened, onClose, colsPref, prefKey }: IProps) => {
  const { update } = useUserPreferences();
  const [columns, setColumns] = useState([
    { label: 'País', name: 'country', checked: false },
    { label: 'Estado', name: 'state', checked: false },
    { label: 'Cidade', name: 'city', checked: false }
  ]);
  const toast = Toast()

  useEffect(() => {
    columns.forEach(c => c.checked = colsPref.includes(c.name));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [colsPref]);

  const handleSave = useCallback(() => {
    const cols = columns.filter(c => c.checked).map(c => c.name);
    const userPref = { key: prefKey, data: cols };

    userPreferencesService.save(userPref)
      .then(() => {
        update(userPref);
        onClose();
        toast.success();
      })
      .catch(() => toast.error());

  }, [onClose, columns, update]);

  const handleClick = useCallback((e: ChangeEvent<HTMLInputElement>) => {
    const cols = [...columns];
    let item = cols.find(c => c.name === e.currentTarget.id);

    if (item)
      item.checked = e.currentTarget.checked;

    setColumns(cols);
  }, [columns]);

  return (
    <Modal isOpen={opened} onClose={onClose}>
      <ModalOverlay />
      <ModalContent style={modalStyle}>
        <ModalHeader>Exibir/Ocultar colunas</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          {columns.map(c =>
            <Checkbox key={c.name}>
              <input id={c.name} type="checkbox" checked={c.checked} onChange={handleClick} />
              <label htmlFor={c.name}>{c.label}</label>
            </Checkbox>
          )}
        </ModalBody>
        <ModalFooter>
          <Button variantColor="blue" mr={3} onClick={handleSave}>Salvar</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

export default UserPreferences;